module.exports = "/images/delivery.svg";